import { render } from "./PrepareList.vue?vue&type=template&id=60c38fa6&scoped=true"
import script from "./PrepareList.vue?vue&type=script&lang=js"
export * from "./PrepareList.vue?vue&type=script&lang=js"

import "./PrepareList.vue?vue&type=style&index=0&id=60c38fa6&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c38fa6"]])

export default __exports__